import { TOPPTIPSET_PRODUCTS } from 'shared/constants/AppConstants';

const maybeUpper = (text, upper) => (upper ? text.toUpperCase() : text);

const name = product => {
  switch (product) {
    case 'WmTipset': {
      return 'VM-Tipset';
    }
    case 'TopptipsetEuropa':
    case 'TopptipsetStryk': {
      return 'Topptipset';
    }
    case 'PowerPlay': {
      return 'Powerplay';
    }
    case 'T': {
      return 'Trio';
    }
    default:
    // Do nothing
  }
  return product;
};

export const getProductDisplayName = (product, uppercase = false) =>
  maybeUpper(name(product), uppercase);

export const isTopptipset = product => TOPPTIPSET_PRODUCTS.includes(product);
